import { render } from "./video_player.vue?vue&type=template&id=11663693"
import script from "./video_player.vue?vue&type=script&lang=js"
export * from "./video_player.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__